import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openFinanceSlideout } from '../../actions/lister-actions';

import TRANSLATIONS from '../../translations/translations@default.json';
import { getFinanceData } from '../../utilities/finance-utilities';
import FinanceWithChevron from './FinanceWithChevron';
import InterestFreeCreditButton from './InterestFreeCreditButton';

const FinanceProposition = ({
	NewDayFinanceQuote,
	FullTitle,
	Promotions: { FinancePromotions } = {},
	PricePodViewModel: { NowPrice, MemberPrice } = {},
	classes,
	Code,
	ColourId,
	State,
}) => {
	const dispatch = useDispatch();

	const { AnnualMembershipFee } = useSelector((state) => state.featureSwitches);
	const { FinancePromotionText } = useSelector(
		(state) => state.featureSwitches
	);
	const { DeliveryPricingInPricePod } = useSelector(
		(state) => state.featureSwitches
	);

	const date = new Date();
	const buyNowPayLaterYear = date.getFullYear() + 1;

	const financeData =
		FinancePromotions?.length > 0
			? getFinanceData(FinancePromotions[0].ImageName, NowPrice)
			: null;

	if (financeData && NewDayFinanceQuote?.PriceIsLessThanMinimum === false) {
		switch (financeData.type) {
			case 'InterestFree':
				return (
					<>
						{DeliveryPricingInPricePod && (
							<h3 className="text-title-sm mt-4">AO Finance</h3>
						)}
						<FinanceWithChevron
							NewDayFinanceQuote={NewDayFinanceQuote}
							productTitle={FullTitle}
							MemberPrice={MemberPrice}
							NowPrice={NowPrice}
							Code={Code}
							ColourId={ColourId}
							financeType="interest-free"
							financePromotions={FinancePromotions}
							State={State}
						/>
						<InterestFreeCreditButton
							financeData={financeData}
							classes={classes}
							fullTitle={FullTitle}
							NowPrice={NowPrice}
							MemberPrice={MemberPrice}
							Code={Code}
							ColourId={ColourId}
							financePromotions={FinancePromotions}
							State={State}
						/>
					</>
				);
			case 'BuyNowPayLater':
				return (
					<>
						{DeliveryPricingInPricePod && (
							<h3 className="text-title-sm mt-4">AO Finance</h3>
						)}
						<FinanceWithChevron
							NewDayFinanceQuote={NewDayFinanceQuote}
							productTitle={FullTitle}
							MemberPrice={MemberPrice}
							NowPrice={NowPrice}
							Code={Code}
							ColourId={ColourId}
							financeType="buy-now-pay-later"
							financePromotions={FinancePromotions}
						/>
						<button
							type="button"
							aria-label="Buy Now Pay Later Finance Promotion"
							className={`${classes} relative z-10 p-0 w-full mt-2 lg:mt-4 bg-transparent`}
							onClick={() => {
								dispatch(
									openFinanceSlideout({
										productId: ColourId,
										productSku: Code,
										nowPrice: NowPrice,
										memberPrice: MemberPrice,
										annualMembershipFee: AnnualMembershipFee,
										financePromotionCodes: FinancePromotions.map(
											(p) => p.PromotionCode
										),
										isInStock: State !== 'OutOfStock',
									})
								);
							}}
							data-tag-name="finance-buy-now-pay-later-button"
							data-tag-finance-type="finance-buy-now-pay-later-button"
							data-tag-product={FullTitle}
							data-testid="finance-buy-now-pay-later">
							<div className="flex flex-row items-center bg-steam p-1 rounded-sm text-title-sm text-xs">
								<span className="px-2 flex-grow">{FinancePromotionText}</span>
								<i className="ico ico-chevron-right text-xl text-cta-action" />
							</div>
						</button>
					</>
				);
			default:
				return null;
		}
	}

	// finance messaging
	if (NewDayFinanceQuote?.PriceIsLessThanMinimum === false) {
		return (
			<>
				{DeliveryPricingInPricePod && (
					<h3 className="text-title-sm mt-4">AO Finance</h3>
				)}
				<FinanceWithChevron
					NewDayFinanceQuote={NewDayFinanceQuote}
					productTitle={FullTitle}
					MemberPrice={MemberPrice}
					NowPrice={NowPrice}
					Code={Code}
					ColourId={ColourId}
					financeType="finance-instalments"
					financePromotions={FinancePromotions}
				/>
			</>
		);
	}

	return financeData?.type === 'InterestFree' ? (
		<InterestFreeCreditButton
			financeData={financeData}
			classes={classes}
			fullTitle={FullTitle}
			NowPrice={NowPrice}
			MemberPrice={MemberPrice}
			Code={Code}
			ColourId={ColourId}
			financePromotions={FinancePromotions}
			State={State}
		/>
	) : (
		<button
			type="button"
			aria-label="Flexible Credit Finance Promotion"
			className={`${classes} relative z-10 p-0 w-full mt-2 bg-transparent`}
			onClick={() => {
				dispatch(
					openFinanceSlideout({
						productId: ColourId,
						productSku: Code,
						nowPrice: NowPrice,
						memberPrice: MemberPrice,
						annualMembershipFee: AnnualMembershipFee,
						financePromotionCodes: FinancePromotions.map(
							(p) => p.PromotionCode
						),
						isInStock: State !== 'OutOfStock',
					})
				);
			}}
			data-tag-name="finance-flexible-credit-button"
			data-tag-finance-type="finance-flexible-credit-button"
			data-tag-product={FullTitle}
			data-testid="finance-flexible-credit">
			<div className="flex flex-row items-center bg-white border border-gray-30 border-solid p-2 rounded text-xs text-left">
				<i className="ico ico-finance-gbp text-xl text-cta-main" />
				<span className="px-2 flex-grow text-gray-100">
					{
						TRANSLATIONS.productList.productCard.financeRestyle
							.aoFinanceAvailable
					}
				</span>
				<i className="ico ico-chevron-right text-xl text-cta-action" />
			</div>
		</button>
	);
};

export default FinanceProposition;
